import { render, staticRenderFns } from "./JitsiSecureMeeting.vue?vue&type=template&id=0018e7a3"
import script from "./JitsiSecureMeeting.vue?vue&type=script&lang=js"
export * from "./JitsiSecureMeeting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports